import React, { Component } from "react";
import { connect } from "react-redux";

//Components
import { Analytics, Overview, Setpoints, Schedule } from "./dashboard_tabs";

//Deps
import { Paper, Tab, Tabs, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

//Icons
import EventIcon from "@material-ui/icons/Event";
import HomeIcon from "@material-ui/icons/Home";
import TimelineIcon from "@material-ui/icons/Timeline";
import TuneIcon from "@material-ui/icons/Tune";

function mapStateToProps(state) {
  return {
    isEngineer: state.user.currentUser.profile.email === "engineer@fourseasonsclimate.com"
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

//Tab container
function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: ".25em 0" }}>
      {props.children}
    </Typography>
  );
}

//Styles
const styles = theme => ({
  root: {
    width: "100%"
  },
  paper: {
    width: "100%",
    paddingTop: "1em"
  },
  icon: {
    paddingBottom: "10px"
  },
  container: {
    // padding: "2em"
  },
  key: {
    fontSize: "1.5em",
    fontWeight: "bold",
    marginTop: "1em"
  }
});

class ClientDashboard extends Component {
  constructor() {
    super();
    this.state = {
      value: 0
    };
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const { classes, isEngineer } = this.props;

    if (isEngineer) {
      return (
        <div className={classes.root}>
          <Paper className={classes.paper} square>
            <Tabs
              value={this.state.value}
              onChange={this.handleChange}
              variant="fullWidth"
              indicatorColor="secondary"
              textColor="secondary"
              style={{ display: "flex", justifyContent: "space-evenly" }}>
              <Tab icon={<TuneIcon />} className={classes.icon} />
            </Tabs>
          </Paper>
          <div className={classes.container}>
            {this.state.value === 0 && (
              <TabContainer>
                <Setpoints />
              </TabContainer>
            )}
          </div>
        </div>
      );
    }

    return (
      <div className={classes.root}>
        <Paper className={classes.paper} square>
          <Tabs
            value={this.state.value}
            onChange={this.handleChange}
            fullWidth
            indicatorColor="secondary"
            textColor="secondary">
            <Tab icon={<HomeIcon />} className={classes.icon} />
            <Tab icon={<TuneIcon />} className={classes.icon} />
            <Tab icon={<TimelineIcon />} className={classes.icon} />
            <Tab icon={<EventIcon />} className={classes.icon} />
          </Tabs>
        </Paper>
        <div className={classes.container}>
          {this.state.value === 0 && (
            <TabContainer>
              <Overview />
            </TabContainer>
          )}
          {this.state.value === 1 && (
            <TabContainer>
              <Setpoints />
            </TabContainer>
          )}
          {this.state.value === 2 && (
            <TabContainer>
              <Analytics />
            </TabContainer>
          )}

          {this.state.value === 3 && (
            <TabContainer>
              <Schedule />
            </TabContainer>
          )}
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ClientDashboard));



// WEBPACK FOOTER //
// ./src/pages/client_dashboard/ClientDashboard.js